import React, {
  useState,
  useEffect,
  useRef,
  Fragment,
  useCallback,
  useMemo,
} from 'react';
import {
  DataTable,
  Button,
  Input,
  Label,
  Switch,
  SpinnerLoader,
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
  PageHeader,
  Search,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetFooter,
} from 'lift-ui';
import type { TableColumn } from 'lift-ui';
import {
  RefreshCw,
  Plus,
  Edit,
  ImageIcon,
  ExternalLink,
} from 'lucide-react';
import axios from 'axios';
import moment from 'moment';
import { useSelector } from 'react-redux';
import MultipleSelectChip from '../../shared/components/multiple-input';
import isValidDomain from 'is-valid-domain';
import isEmail from 'validator/lib/isEmail';
import { parseISO } from 'date-fns';
import { useThrottledFn } from '@lift-admin/utils/throttle';
import { Toastify } from 'lift-ui';
import { actionLogTrack } from '@lift-admin/utils/actionLogTrack';
import {
  buildSummary,
  buildDetails,
  diffFields,
  humanizeValue,
} from '@lift-admin/utils/logChangeFormatter';
import { debounce } from '@lift-admin/utils/debounce';
import apiClient from '@lift-admin/utils/apiClient';
import { actionLog } from '../../App';
import { useAuthContext } from '@lift-admin/utils/provider';

const types: any[] = [
  {
    value: 'New',
    label: 'New',
  },
  {
    value: 'Takeover',
    label: 'Takeover',
  },
];

// const demoID = [
//   1,
//   2,
//   3,
//   4,
//   5
// ];
const demoID = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
];

const demoID2 = [
  { value: 119, label: '119' },
  { value: 120, label: '120' },
  { value: 121, label: '121' },
  { value: 122, label: '122' },
  { value: 123, label: '123' },
  { value: 124, label: '124' },
];

const date_presets_list = [
  {
    label: 'Custom',
    data: ['Custom Range', 'On Going'],
  },
  {
    label: 'To Date',
    data: [
      'Yesterday',
      'Week to Date',
      'Bi-Week to date',
      'Month to date',
      'Quarter to date',
      'Year to date',
    ],
  },
  {
    label: 'Previous',
    data: [
      'Previous Week',
      'Previous BI-Week',
      'Previous Month',
      'Previous Month',
      'Previous Quarter',
      'Previous Year',
    ],
  },
  {
    label: 'Last',
    data: ['Last 7 Days', 'Last 14 Days', 'Last 28 Days', 'Last 90 Days'],
  },
  {
    label: 'This',
    data: [
      'This Week',
      'This BI-Week',
      'This Month',
      'This Quarter',
      'This Year',
    ],
  },
  {
    label: 'Custom Date Ranges',
    data: [
      'Day Before Yesterday',
      'Last 180 Days',
      'Last 180 Days Thru Today',
      'Last 2 Days',
      'Last 2 Days Thru Today',
      'Last 28 Days Thru Today',
      'Last 3 Days',
      'Last 3 Days Thru Today',
      'Last 30 Days Thru Today',
      'Last 4 Days',
      'Last 4 Days Thru Today',
      'Last 60 Days Thru Today',
      'Last 90 Days Thru Today',
      'Latest 4 Quarters (including current)',
      'Month to Date Thru Yesterday',
      'Oct 2021 Thru Today',
      'Past 11 Weeks (Sun-Sat)',
      'Past 12 Weeks (Mon-Sun)',
      'Past 12 Weeks (Sun-Sat, including current week)',
      'Past 12 Weeks (Sun-Sat)',
      'Past 12 Weeks (Tues-Mon)',
      'Past 2 Months',
      'Past 2 Months Thru MTD',
      'Past 2 Weeks (Mon-Sun)',
      'Past 3 Months',
      'Past 3 Months Thru MTD',
      'Past 3 Weeks (Mon-Sun)',
      'Past 4 Weeks (Mon-Sun)',
      'Past 4 Weeks (Sun-Sat)',
      'Past 4 Weeks (Tues-Mon)',
      'Past 4 Weeks (Wed-Tues)',
      'Past 53 Weeks (Mon-Sun)',
      'Past 6 Weeks (Mon-Sun)',
      'Past 6 Weeks (Sun-Sat)',
      'Past 6 Weeks (Tues-Mon)',
      'Past 6 Weeks (Wed-Tues)',
      'Past Week (Mon-Sun)',
      'Past Week (Sun-Sat)',
      'Past Week (Tues-Mon)',
      'Previous Week (Mon-Sun)',
      'Today',
      'Year to Date Thru Yesterday',
    ],
  },
];

const OrganizationDown = () => {
  const [organizations, setOrganizations] = useState<any>([]);
  const [usersSearched, setUsersSearched] = useState<any>([]);
  const [organizationsBackup, setOrganizationsBackup] = useState<any>([]);
  const [page, setPage] = useState<any>(0);
  const [rowsPerPage, setRowsPerPage] = useState<any>(25);
  const inputFile: any = useRef(null);
  const csvInput: any = useRef(null);
  const [showAddBrandDialog, setShowAddBrandDialog] = useState<any>(false);
  const [addOrgImageRaw, setAddOrgImageRaw] = useState<any>(null);
  const [addOrgImage, setAddOrgImage] = useState<any>(null);
  const [addOrgname, setAddOrgName] = useState<any>('');
  const [addOrgIsActive, setAddOrgIsActive] = useState<any>(false);

  const [addAlias, setAddAlias] = useState<any>('');
  const [addBrandDate, setAddBrandDate] = useState<any>(new Date());
  const [addBrandVertical, setAddBrandVertical] = useState<any>([]);
  const [addBrandType, setAddBrandType] = useState<any>('');
  const [addBrandDomain, setAddBrandDomain] = useState<any>('');
  const [hideAddBrandProgressDialog, setHideAddBrandProgressDialog] =
    useState<any>(true);
  const editInputFile: any = useRef(null);
  const [editOrgData, setEditOrgData] = useState<any>();
  const [showEditBrandDialog, setShowEditBrandDialog] = useState<any>(false);
  const [editOrgImageRaw, setEditOrgImageRaw] = useState<any>(null);
  const [editOrgImage, setEditOrgImage] = useState<any>(null);
  const [editIsActive, setEditIsActive] = useState<any>(false);
  const [editBrandImageChange, setEditBrandImageChange] = useState<any>(0);
  const [editOrgName, setEditOrgName] = useState<any>(null);
  const [editBrandDatePreset, setEditBrandDatePreset] = useState<any>();
  const [editAlias, setEditAlias] = useState<any>();
  const [editBrandDate, setEditBrandDate] = useState<any>();
  const [editBrandVertical, setEditBrandVertical] = useState<any>([]);
  const [editBrandVerticalChange, setEditBrandVerticalChange] = useState<any>();
  const [editBrandType, setEditBrandType] = useState<any>('');
  const [editBrandDomain, setEditBrandDomain] = useState<any>();
  const [editBrandDomainChange, setEditBrandDomainChange] = useState<any>();
  const [hideEditBrandProgressDialog, setHideEditBrandProgressDialog] =
    useState<any>(true);
  const [editSOWLink, setEditSOWLink] = useState<any>(null);
  const [editMSALink, setEditMSALink] = useState<any>(null);
  const [editContractTerms, setEditContractTerms] = useState<any>(null);
  const [editDirectorID, setEditDirectorID] = useState<any>(null);
  const [editManagerID, setEditManagerID] = useState<any>(null);
  const [editAssociateID1, setEditAssociateID1] = useState<any>(null);
  const [editAssociateID2, setEditAssociateID2] = useState<any>(null);
  const [editOpsID, setEditOpsID] = useState<any>(null);
  const [editDateJoined, setEditDateJoined] = useState<any>(null);
  const [showAdditionalFields, setShowAdditionalFields] = useState<any>(false);
  const [allUsers, setAllUsers] = useState<any>([]);
  const { admin_auth, superAdmin } = useSelector((state: any) => state.admin);

  console.log('edit', editIsActive);

  //search
  const [searchText, setSearchText] = useState<any>('');
  const [searchTextUser, setSearchTextUser] = useState<any>('');
  const [searchedBrands, setSearchedBrands] = useState<any>([]);
  const [searchQuery, setSearchQuery] = useState<any>('');
  const [selectedDatePreset, setSelectedDatePreset] = useState<any>('');

  const [selectedItem, setSelectedItem] = useState<any>(1);
  const [csvData, setCsvData] = useState<any[]>([]);
  const [fileName, setFileName] = useState<string>('');

  // Update Active Status of Organization (Lift UI dialog confirmation)
  const [aboutToUpdateActiveOrgShow, setAboutToUpdateActiveOrgShow] =
    useState<any>(false);
  const [aboutToUpdateActiveOrgProgress, setAboutToUpdateActiveOrgProgress] =
    useState<any>(false);
  const [aboutToUpdateActiveOrg, setAboutToUpdateActiveOrg] =
    useState<any>(null);

  const [selectedIsActive, setSelectedIsActive] = useState<any>(true);

  const scrollHeader: any = useRef<any>(null);

  const { canEdit, canManage, canView, loading: authLoading } = useAuthContext();

  // Check if user has edit permission for brand management
  const hasEditAccess = canEdit('brand_mgmt');
  // Check if user has manage/delete permission for brand management
  const hasManageAccess = canManage('brand_mgmt');
  // Viewers (and above) can list organizations; edit actions stay gated by hasEditAccess / superAdmin
  const canSeeOrganizations = canView('brand_mgmt');

  console.log(searchQuery, 'searchQuery');

  console.log(selectedIsActive, 'active');
  console.log(editIsActive, 'active');

  const date = new Date(0);
  const [sorting, setSorting] = useState<{ key: string; direction: 'asc' | 'desc' } | undefined>(undefined);
  useEffect(() => {
    setEditDateJoined(date.toISOString());
  }, []);
  useEffect(() => {
    console.log(editDateJoined, 'editDateJoined');
  }, [editDateJoined]);

  // Format Date
  const formatDate = (timeStamp: any) => {
    let date = new Date(timeStamp);
    return (
      date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
    );
  };

  // Update data on page change
  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  // Update data when rows per page count is changed
  const handlePageSizeChange = (newPageSize: number) => {
    setRowsPerPage(newPageSize);
    setPage(0);
  };

  const [totalOrgsCount, setTotalOrgsCount] = useState(0);
  const searchQueryRef = useRef('');
  const [loadList, setLoadList] = useState(true);

  // Wait for auth permissions before skipping fetch (viewers get canView after JWT loads).
  const getOrganizationsPage = useCallback(
    async (pageIndex: number, pageSize: number, search?: string) => {
      if (!canSeeOrganizations) {
        setLoadList(false);
        return;
      }

      setLoadList(true);
      try {
        const params: any = { page: pageIndex + 1, limit: pageSize };
        if (search && search.trim()) {
          params.search = search.trim();
        }
        const res = await apiClient.get(`/brand/v1/organizations/all`, { params });
        if (!res?.data?.response) {
          Toastify('error', 'Error while fetching organizations');
          return;
        }
        const items = res.data.response ?? [];
        const pagination = res.data.pagination;

        setOrganizations(items);
        if (pagination) {
          setTotalOrgsCount(pagination.total ?? items.length);
        } else {
          setTotalOrgsCount(items.length);
        }
      } catch (err: any) {
        Toastify('error', err?.response?.data?.message ?? 'Error while getting organizations');
        console.error(err);
      } finally {
        setLoadList(false);
      }
    },
    [canSeeOrganizations]
  );

  const getOrganizations = () => {
    getOrganizationsPage(page, rowsPerPage, searchQueryRef.current);
  };

  useEffect(() => {
    if (authLoading) {
      return;
    }
    if (!canSeeOrganizations) {
      setLoadList(false);
      return;
    }
    getOrganizationsPage(page, rowsPerPage, searchQueryRef.current);
  }, [authLoading, canSeeOrganizations, page, rowsPerPage, getOrganizationsPage]);

  const throttleGetBrands = useThrottledFn(getOrganizations, 1000);

  const customSortBasedOnDate = (a: any, b: any) => {
    if (superAdmin) {
      return (
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
    } else {
      return (
        new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
      );
    }
  };

  const resetAddBrand = () => {
    setAddOrgImageRaw(null);
    setAddOrgImage(null);
    setAddOrgName('');
    setAddAlias('');
    setAddBrandDate(new Date());
    setAddBrandVertical([]);
    setAddBrandType('');
    setAddBrandDomain('');
    setHideAddBrandProgressDialog(true);
    setShowAddBrandDialog(false);
  };

  // Add brand to db
  const addOrganization = () => {
    if (!hasEditAccess) {
      Toastify('error', 'You do not have permission to add organizations');
      return;
    }
    if (
      typeof addOrgname === 'undefined' ||
      addOrgname === null ||
      addOrgname === ''
    ) {
      Toastify('warning', 'Name of Organization is required!');
    } else if (
      typeof addOrgIsActive === 'undefined' ||
      addOrgIsActive === null ||
      addOrgIsActive === ''
    ) {
      Toastify(
        'warning',
        'IsActive of Organization should be either true or false'
      );
    } else {
      setHideAddBrandProgressDialog(false);
      if (addOrgImage === null) {
        const formData = new FormData();

        formData.append('name', addOrgname);
        formData.append('is_active', selectedIsActive ? 'true' : 'false');

        apiClient
          .post(`/brand/v1/organizations`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })

          .then(async (res) => {
            setHideAddBrandProgressDialog(true);
            setShowAddBrandDialog(false);
            setAddOrgName('');
            setAddBrandDomain('');
            getOrganizations();

            const desc = {
              message: buildSummary('Organization', addOrgname, 'created'),
              status: res.status,
              method: res.config.method,
              url: res.config.url,
              category: 'organization',
              organizationName: addOrgname,
              details: buildDetails(
                { name: addOrgname, is_active: selectedIsActive },
                [
                  { key: 'name', label: 'Name' },
                  { key: 'is_active', label: 'Status', type: 'boolean', boolStyle: 'activeInactive' },
                ]
              ),
            };

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(desc), false);

            Toastify('success', 'Organizations added successfully!');
          })
          .catch(async (error) => {
            console.error(error, 'from Organization');
            if (error.response) {
              Toastify('error', error.response.data.message);
            } else {
              Toastify('error', 'Somthing went wrong !!');
            }

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(error), true);
          });
      } else {
        // let formData = {
        //   // organization: {
        //     name: addOrgname,
        //     is_active: selectedIsActive,
        //     image_url: addOrgImageRaw,
        //   // },
        // };

        const formData = new FormData();

        formData.append('name', addOrgname);
        formData.append('is_active', selectedIsActive ? 'true' : 'false');
        formData.append('image_url', addOrgImageRaw);

        apiClient
          .post(`/brand/v1/organizations`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })

          .then(async (res) => {
            setHideAddBrandProgressDialog(true);
            setShowAddBrandDialog(false);
            setAddOrgImage(null);
            setAddOrgName('');
            setSelectedIsActive(false);
            getOrganizations();

            const desc = {
              message: buildSummary('Organization', addOrgname, 'created'),
              status: res.status,
              method: res.config.method,
              url: res.config.url,
              category: 'organization',
              organizationName: addOrgname,
              details: buildDetails(
                { name: addOrgname, is_active: selectedIsActive, image: 'uploaded' },
                [
                  { key: 'name', label: 'Name' },
                  { key: 'is_active', label: 'Status', type: 'boolean', boolStyle: 'activeInactive' },
                  { key: 'image', label: 'Logo' },
                ]
              ),
            };

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(desc), false);

            Toastify('success', 'Organizations added successfully!');
          })
          .catch(async (error) => {
            console.error(error, 'from Organization');

            if (error.response) {
              Toastify('error', error.response.data.message);
            } else {
              Toastify('error', 'Somthing went wrong !!');
            }

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(error), true);
          });
      }
    }
  };

  // edit organization
  const editOrg = (organization: any) => {
    if (!hasEditAccess) {
      Toastify('error', 'You do not have permission to edit organizations');
      return;
    }
    console.log('orgs', organization);

    setEditOrgData(organization);
    setEditOrgImage(superAdmin ? organization.image_url : organization.image);
    setEditOrgImageRaw(null);
    setEditIsActive(
      superAdmin ? (organization.is_active ? true : false) : false
    );
    setEditOrgName(superAdmin ? organization.name : organization.name);

    setShowEditBrandDialog(true);
  };

  const changeDetect = () => {
    const organization = editOrgData?.id != null
      ? organizationsBackup.find((b: any) => b.id == editOrgData.id)
      : undefined;
    const changes = [];
    if (editOrgData && organization) {
      if (organization.name !== editOrgName) {
        changes.push(`${organization.name} => ${editOrgName} (name)`);
      }
      if (organization.is_active !== editIsActive) {
        changes.push(
          `${organization.is_active} => ${editIsActive} (is_active)`
        );
      }
      if (editOrgImageRaw !== null) {
        changes.push('image');
      }
    }
    return changes;
  };

  // Effect to call updateOrganization when editOrgName changes
  useEffect(() => {
    if (aboutToUpdateActiveOrg) {
      if (
        editOrgName !== aboutToUpdateActiveOrg.name &&
        editIsActive !== !aboutToUpdateActiveOrg.is_active
      ) {
        updateOrganization();
      }
    }
  }, [editOrgName, editIsActive]);

  // Update Organization Active Status (called from Lift UI dialog confirm)
  const updateActiveOrgStatusWithRow = async (row: any) => {
    if (!hasEditAccess) {
      Toastify('error', 'You do not have permission to update organization status');
      return;
    }
    setAboutToUpdateActiveOrgProgress(true);

    const formData = {
      is_active: row.is_active ? 'false' : 'true',
    };

    try {
      const res = await apiClient.put(
        `/brand/v1/organizations/${row.id}`,
        formData
      );

      if (res.data.message) {
        setAboutToUpdateActiveOrgProgress(false);
        setAboutToUpdateActiveOrgShow(false);
        setAboutToUpdateActiveOrg(null);
        getOrganizations();
        Toastify('success', res.data.message);
        const desc = {
          message: buildSummary('Organization', row?.name, !row?.is_active ? 'activated' : 'deactivated'),
          status: res.status,
          method: res.config.method,
          url: res.config.url,
          category: 'organization',
          organizationId: row?.id,
          organizationName: row?.name,
          changes: [
            {
              label: 'Status',
              from: humanizeValue(row?.is_active, { type: 'boolean', boolStyle: 'activeInactive' }),
              to: humanizeValue(!row?.is_active, { type: 'boolean', boolStyle: 'activeInactive' }),
            },
          ],
        };

        if (actionLog) await actionLog.actionLogTrack(JSON.stringify(desc), false);
      }
    } catch (error: any) {
      setAboutToUpdateActiveOrgProgress(false);
      setAboutToUpdateActiveOrgShow(false);
      setAboutToUpdateActiveOrg(null);
      getOrganizations();
      Toastify('error', error?.response?.data?.message || error?.message || 'Something went wrong');
      if (actionLog) await actionLog.actionLogTrack(JSON.stringify(error), true);
    }
  };

  // update organization
  const updateOrganization = () => {
    if (!hasEditAccess) {
      Toastify('error', 'You do not have permission to update organizations');
      return;
    }
    if (
      typeof editOrgName === 'undefined' ||
      editOrgName === null ||
      editOrgName === ''
    ) {
      Toastify(
        'warning',
        'Organization name is required.'
      );
      return;
    }
    if (editOrgImageRaw === null) {
      const changeVar = changeDetect();
      console.log(changeVar, 'changevar');

      setHideEditBrandProgressDialog(false);

      if (superAdmin) {
        const formData = new FormData();

        formData.append('name', editOrgName);
        formData.append('is_active', editIsActive ? 'true' : 'false');
        // formData.append("image_url", editOrgImageRaw);

        console.log('data', formData);

        apiClient
          .put(`/brand/v1/organizations/${editOrgData.id}`, formData)

          .then(async (res) => {
            const oldOrg =
              organizationsBackup.find((b: any) => b.id == editOrgData?.id) || editOrgData || {};
            const orgChanges = diffFields(
              { name: oldOrg.name, is_active: oldOrg.is_active },
              { name: editOrgName, is_active: editIsActive },
              [
                { key: 'name', label: 'Name' },
                { key: 'is_active', label: 'Status', type: 'boolean', boolStyle: 'activeInactive' },
              ]
            );
            if (editOrgImageRaw !== null) {
              orgChanges.push({ label: 'Logo', from: 'Previous logo', to: 'New logo uploaded' });
            }
            const desc = {
              message: buildSummary('Organization', editOrgName || editOrgData?.name, 'updated', orgChanges.length),
              status: res.status,
              method: res.config.method,
              url: res.config.url,
              category: 'organization',
              organizationId: editOrgData?.id,
              organizationName: editOrgName || editOrgData?.name,
              changes: orgChanges,
            };

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(desc), false);

            Toastify('success', 'Organization updated!');
            setHideEditBrandProgressDialog(true);
            setShowEditBrandDialog(false);
            setShowAdditionalFields(false);
            setEditOrgImage('');
            setEditOrgName('');
            setEditOrgData('');

            getOrganizations();
          })
          .catch(async (error) => {
            console.log('err', error);
            if (error.response) {
              Toastify('error', error.response.data.message);
            } else {
              Toastify('error', 'Somthing went wrong !!');
            }

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(error), true);
            setHideEditBrandProgressDialog(true);
          });
      } else {
        setHideEditBrandProgressDialog(true);
        Toastify('warning', 'Only super admin can update organization details.');
      }
    } else {
      const changeVar = changeDetect();
      console.log(changeVar, 'changevar');

      setHideEditBrandProgressDialog(false);

      if (superAdmin) {
        const formData = new FormData();

        formData.append('name', editOrgName);
        formData.append('is_active', editIsActive ? 'true' : 'false');
        formData.append('image_url', editOrgImageRaw);

        apiClient
          .put(`/brand/v1/organizations/${editOrgData.id}`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })

          .then(async (res) => {
            const oldOrg =
              organizationsBackup.find((b: any) => b.id == editOrgData?.id) || editOrgData || {};
            const orgChanges = diffFields(
              { name: oldOrg.name, is_active: oldOrg.is_active },
              { name: editOrgName, is_active: editIsActive },
              [
                { key: 'name', label: 'Name' },
                { key: 'is_active', label: 'Status', type: 'boolean', boolStyle: 'activeInactive' },
              ]
            );
            if (editOrgImageRaw !== null) {
              orgChanges.push({ label: 'Logo', from: 'Previous logo', to: 'New logo uploaded' });
            }
            const desc = {
              message: buildSummary('Organization', editOrgName, 'updated', orgChanges.length),
              status: res.status,
              method: res.config.method,
              url: res.config.url,
              category: 'organization',
              organizationId: editOrgData?.id,
              organizationName: editOrgName,
              changes: orgChanges,
            };

            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(desc), false);

            console.log('formData:', formData);
            Toastify('success', 'Organization updated');
            setHideEditBrandProgressDialog(true);
            setShowEditBrandDialog(false);
            setShowAdditionalFields(false);
            setEditOrgImageRaw(null);
            setEditOrgImage('');
            setEditOrgName('');
            setAboutToUpdateActiveOrgProgress(false);
            setAboutToUpdateActiveOrg(null);
            setEditOrgData('');
            getOrganizations();
          })
          .catch(async (error) => {
            console.error(error);
            if (error.response) {
              Toastify('error', error.response.data.message);
            } else {
              Toastify('error', 'Somthing went wrong !!');
            }
            if (actionLog) await actionLog.actionLogTrack(JSON.stringify(error), true);
            setHideEditBrandProgressDialog(true);
          });
      } else {
        setHideEditBrandProgressDialog(true);
        Toastify('warning', 'Only super admin can update organization logo.');
      }
    }
  };

  // Search result — server-side
  const searchResults = (query: any) => {
    setPage(0);
    setSearchQuery(query);
    searchQueryRef.current = query;
    getOrganizationsPage(0, rowsPerPage, query);
  };

  const moveScroll = (direction: any) => {
    if (scrollHeader && scrollHeader.current) {
      if (direction) {
        scrollHeader.current.scrollLeft += 150;
      } else {
        scrollHeader.current.scrollLeft -= 150;
      }
    }
  };

  const searchResultsUsers = (query: any) => {
    let userSearchResult = [];
    console.log(allUsers, 'allUsers');
    for (let i = 0; i < allUsers.length; i++) {
      if (allUsers[i]['name'].toLowerCase().includes(query.toLowerCase())) {
        userSearchResult.push(allUsers[i]);
      }
    }

    setUsersSearched(userSearchResult);
  };

  const searchOptimized: any = useCallback(debounce(searchResults, 600), []);
  const searchUserOptimized: any = useCallback(
    debounce(searchResultsUsers, 600),
    [allUsers]
  );
  const admin_data: any = localStorage.getItem('admin_auth')
    ? JSON.parse(localStorage.getItem('admin_auth') as string)
    : null;
  const additionalFieldsRef: any = useRef(null);
  const dialogContentRef: any = useRef(null);

  const handleSwitchClick = () => {
    setShowAdditionalFields(!showAdditionalFields);
  };

  useEffect(() => {
    if (additionalFieldsRef.current && showAdditionalFields) {
      additionalFieldsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest',
      });
    }
  }, [showAdditionalFields]);

  const getAllUsers = () => {
    const res = apiClient
      .get(`/user/v1/admin/all`)
      .then((response) => {
        console.log(response.data, 'response.data');
        setAllUsers(response.data.response);
        setLoadList(false);
      })
      .catch((err) => {
        Toastify('error', err.response.data.message);
        console.error(err);
      });
  };
  useEffect(() => {
    getAllUsers();
  }, []);

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (!file) {
      return; // No file selected, do nothing
    }

    // Check for valid Excel file types (.xls and .xlsx)
    const validTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    if (!validTypes.includes(file.type)) {
      // setErrorMessage('Please select a valid Excel file (.xls or .xlsx)');
      return;
    }

    setFileName(file.name);
    // setErrorMessage(''); // Clear any previous error messages

    // Send file directly to backend using FormData
    const formData = new FormData();
    formData.append('excelFile', file);

    // await apiClient
    //   .post("/api", formData)
    //   .then((response:any) => response.json()) // Handle backend response (optional)
    //   .catch((error:any) => console.error(error));
  };

  interface OrganizationRow {
    id: number;
    name: string;
    image_url: string;
    domain: string;
    is_active: boolean;
  }

  const dataTableColumns: TableColumn<OrganizationRow>[] = useMemo(() => {
    const cols: TableColumn<OrganizationRow>[] = [
      {
        key: 'image_url',
        header: 'ORGANIZATION',
        accessor: 'image_url',
        width: '20%',
        render: (_v: any, row: OrganizationRow) => (
          <img
            alt="org-img"
            src={row.image_url}
            className={`h-[60px] w-[120px] object-contain rounded ${row.domain ? 'cursor-pointer' : ''}`}
            onClick={() => row.domain && window.open(`https://${row.domain}`)}
          />
        ),
      },
      {
        key: 'name',
        header: 'NAME',
        accessor: 'name',
        sortable: true,
        width: '30%',
        render: (_v: any, row: OrganizationRow) => (
          <span className="font-medium">{row.name}</span>
        ),
      },
    ];

    if (hasEditAccess) {
      cols.push({
        key: 'is_active',
        header: 'ACTIVE',
        accessor: 'is_active',
        width: '15%',
        align: 'center',
        render: (_v: any, row: OrganizationRow) => (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                <div>
                  <Switch
                    checked={row.is_active}
                    onCheckedChange={() => {
                      setAboutToUpdateActiveOrg(row);
                      setAboutToUpdateActiveOrgShow(true);
                    }}
                  />
                </div>
              </TooltipTrigger>
              <TooltipContent>
                {row.is_active ? 'Click to deactivate' : 'Click to activate'}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        ),
      });
    }

    if (hasEditAccess || hasManageAccess) {
      cols.push({
        key: 'actions',
        header: 'ACTIONS',
        accessor: (row: OrganizationRow) => row.id,
        align: 'center',
        render: (_v: any, row: OrganizationRow) => {
          const visitUrl = row.domain ? `https://${row.domain}` : undefined;
          const actionButtons: React.ReactNode[] = [];

          if (visitUrl) {
            actionButtons.push(
              <TooltipProvider key="visit">
                <Tooltip>
                  <TooltipTrigger asChild>
                    <Button
                      variant="ghost"
                      size="sm"
                      onClick={() => window.open(visitUrl)}
                      className="h-8 w-8 p-0"
                    >
                      <ExternalLink className="h-4 w-4" />
                    </Button>
                  </TooltipTrigger>
                  <TooltipContent>Visit</TooltipContent>
                </Tooltip>
              </TooltipProvider>
            );
          }

          if (hasEditAccess) {
            actionButtons.push(
              <TooltipProvider key="edit">
                <Tooltip>
                  <TooltipTrigger asChild>
                    <span className="inline-flex">
                      <Button
                        variant="ghost"
                        size="sm"
                        onClick={() => editOrg(row)}
                        disabled={!row.is_active}
                        className="h-8 w-8 p-0"
                      >
                        <Edit className="h-4 w-4" />
                      </Button>
                    </span>
                  </TooltipTrigger>
                  <TooltipContent>
                    {row.is_active
                      ? 'Edit'
                      : 'Activate organization to edit'}
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            );
          }

          return (
            <div className="flex items-center justify-center gap-2">
              {actionButtons}
            </div>
          );
        },
      });
    }

    return cols;
  }, [superAdmin, hasEditAccess, hasManageAccess]);

  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      {/* Update Active Status Dialog (Lift UI) */}
      <Dialog
        open={aboutToUpdateActiveOrgShow}
        onOpenChange={(open) => {
          if (!aboutToUpdateActiveOrgProgress) {
            setAboutToUpdateActiveOrgShow(open);
            if (!open) setAboutToUpdateActiveOrg(null);
          }
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Update Organization Active Status</DialogTitle>
          </DialogHeader>
          <div>
            You are about to change the Active status for the organization{' '}
            <strong>{aboutToUpdateActiveOrg?.name}</strong>. Do you want to continue?
          </div>
          <DialogFooter>
            <Button
              variant="outline"
              onClick={() => {
                if (!aboutToUpdateActiveOrgProgress) {
                  setAboutToUpdateActiveOrgShow(false);
                  setAboutToUpdateActiveOrg(null);
                }
              }}
              disabled={aboutToUpdateActiveOrgProgress}
            >
              Cancel
            </Button>
            <Button
              variant="default"
              onClick={() => {
                if (aboutToUpdateActiveOrg && !aboutToUpdateActiveOrgProgress) {
                  updateActiveOrgStatusWithRow(aboutToUpdateActiveOrg);
                }
              }}
              disabled={!aboutToUpdateActiveOrg || aboutToUpdateActiveOrgProgress}
              className="bg-primary hover:bg-primary/90"
            >
              {aboutToUpdateActiveOrgProgress ? (
                <SpinnerLoader className="h-4 w-4 mr-2" />
              ) : (
                'Yes'
              )}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Add Organization Sheet */}
      <Sheet open={showAddBrandDialog} onOpenChange={setShowAddBrandDialog}>
        <SheetContent side="right" className="sm:max-w-md flex flex-col h-full">
          <SheetHeader>
            <SheetTitle>Add Organization</SheetTitle>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto min-h-0 space-y-4 py-4">
            <div
              className="h-48 w-full border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-gray-400 transition-colors relative"
              onClick={() => inputFile.current?.click()}
            >
              <input
                type="file"
                ref={inputFile}
                className="hidden"
                accept="image/*"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  if (event.target.files && event.target.files[0]) {
                    setAddOrgImageRaw(event.target.files[0]);
                    setAddOrgImage(
                      URL.createObjectURL(event.target.files[0])
                    );
                  }
                }}
              />
              {addOrgImage === null ? (
                <div className="flex flex-col items-center gap-2">
                  <ImageIcon className="h-8 w-8 text-gray-400" />
                  <p className="text-sm text-gray-600">Upload Image</p>
                </div>
              ) : (
                <div className="h-full w-full flex items-center justify-center">
                  <img
                    className="max-h-full max-w-full object-contain pointer-events-none"
                    src={addOrgImage}
                    alt="Organization"
                  />
                </div>
              )}
            </div>
            <div className="space-y-2">
              <Label htmlFor="org-name">Name</Label>
              <Input
                id="org-name"
                      required
                placeholder="Eg. - LT Partners"
                      value={addOrgname}
                      onChange={(event) => setAddOrgName(event.target.value)}
                    />
                </div>
              </div>
          <SheetFooter className="gap-2 border-t pt-4 mt-auto flex-shrink-0">
            <Button variant="outline" onClick={() => resetAddBrand()}>
              Cancel
            </Button>
          <Button
              variant="default"
            onClick={() => {
              if (hideAddBrandProgressDialog) {
                addOrganization();
              }
              }}
              disabled={!hideAddBrandProgressDialog}
              className="bg-primary hover:bg-primary/90"
            >
              {hideAddBrandProgressDialog ? (
                'Add'
              ) : (
                <SpinnerLoader className="h-4 w-4 mr-2" />
              )}
          </Button>
          </SheetFooter>
        </SheetContent>
      </Sheet>

      {/* Edit Organization Sheet */}
      <Sheet open={showEditBrandDialog} onOpenChange={setShowEditBrandDialog}>
        <SheetContent side="right" className="sm:max-w-md flex flex-col h-full" ref={dialogContentRef}>
          <SheetHeader>
            <SheetTitle>Edit Organization</SheetTitle>
          </SheetHeader>
          <div className="flex-1 overflow-y-auto min-h-0 space-y-4 py-4">
            <div className="space-y-2">
              <Label>Organization image</Label>
              <div
                className="h-48 w-full border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-gray-400 transition-colors relative"
                onClick={() => editInputFile.current?.click()}
              >
                <input
                  type="file"
                  ref={editInputFile}
                  className="hidden"
                  accept="image/*"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (event.target.files && event.target.files[0]) {
                      if (!superAdmin) {
                        setEditBrandImageChange(1);
                      }
                      setEditOrgImageRaw(event.target.files[0]);
                      setEditOrgImage(
                        URL.createObjectURL(event.target.files[0])
                      );
                    }
                  }}
                />
                {editOrgImage ? (
                  <img
                    className="max-h-full max-w-full object-contain pointer-events-none"
                    src={editOrgImage}
                    alt="Organization"
                  />
                ) : (
                  <div className="flex flex-col items-center gap-2">
                    <ImageIcon className="h-8 w-8 text-gray-400" />
                    <p className="text-sm text-gray-600">
                      Click to upload image
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div className="space-y-2">
              <Label htmlFor="edit-org-name">Name</Label>
              <Input
                id="edit-org-name"
                disabled={!superAdmin}
                      required
                placeholder="Eg. - LT Partners"
                      value={editOrgName}
                      onChange={(event) => setEditOrgName(event.target.value)}
                    />
                </div>
              </div>
          <SheetFooter className="gap-2 border-t pt-4 mt-auto flex-shrink-0">
          <Button
              variant="outline"
              onClick={() => {
                setShowEditBrandDialog(false);
                setShowAdditionalFields(false);
                setHideEditBrandProgressDialog(true);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="default"
            onClick={() => {
              if (hideEditBrandProgressDialog) {
                updateOrganization();
              }
              }}
              disabled={!hideEditBrandProgressDialog}
              className="bg-primary hover:bg-primary/90"
            >
              {hideEditBrandProgressDialog ? (
                'Update'
              ) : (
                <SpinnerLoader className="h-4 w-4 mr-2" />
              )}
          </Button>
          </SheetFooter>
        </SheetContent>
      </Sheet>

      {/* Page Header */}
      <PageHeader
        tabs={[]}
        title="Organizations"
        renderCustomTop={
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={throttleGetBrands}
              className="flex items-center gap-2 h-8 px-3"
            >
              <RefreshCw className="h-4 w-4" />
              Refresh
            </Button>
            {superAdmin && hasEditAccess && (
              <Button
                variant="default"
                size="sm"
                onClick={() => setShowAddBrandDialog(true)}
                className="bg-primary hover:bg-primary/90 flex items-center gap-2 h-8 px-3"
              >
                <Plus className="h-4 w-4" />
                Add Organization
              </Button>
            )}
            {admin_data && (
              <Button
                variant="default"
                size="sm"
                asChild
                className="bg-primary hover:bg-primary/90 h-8 px-3"
              >
                <a
                  rel="noreferrer"
                  href={`https://app.lift.lt.partners/testload?_id=${admin_data.user}&token=${admin_data?.token}&onboard=${1}`}
                  target="_blank"
                >
                  Go to LIFT
                </a>
              </Button>
            )}
            <div className="relative ml-auto">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Search organizations..."
                className="pl-10 w-80"
                value={searchText}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setSearchText(e.target.value);
                  searchOptimized(e.target.value);
                }}
              />
            </div>
          </div>
        }
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-h-0 px-8 pt-8 pb-4">
        <div className="flex-1 min-h-0">
          <DataTable<OrganizationRow>
            className="flex-1 min-h-0 overflow-auto"
            maxHeight="calc(100vh - 170px)"
            columns={dataTableColumns}
            data={organizations}
            loading={loadList}
            emptyMessage="No organizations found."
            stickyHeader
            stickyFooter
            showActions={false}
            onSort={(key, direction) => {
              setSorting({ key, direction });
            }}
            sortConfig={sorting}
            pagination={{
              currentPage: page + 1,
              totalPages: Math.max(1, Math.ceil(totalOrgsCount / rowsPerPage)),
              pageSize: rowsPerPage,
              totalItems: totalOrgsCount,
              onPageChange: (p) => handlePageChange(p - 1),
              onPageSizeChange: handlePageSizeChange,
              pageSizeOptions: [25, 50, 100, 200],
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default OrganizationDown;
